import React, { useMemo, useRef } from "react";
import { Badge, Button, Col, Form, InputGroup, Modal, Row, Spinner, Table } from "react-bootstrap";
import Fontstyling, {
    clientListDrpDwnStyles,
} from "../../../components/common/comman";
import { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { IoEyeOutline } from "react-icons/io5";
import '../ReviewBlockPricing/style.css';
import CustomReactMaterialTable from "../../../components/common/CustomReactMaterialTable";
import { CreateOrUpdateRxBlockPricing, GetAllAccessConditionsbysizeorcost, GetAllGPO, GetAllPBM, GetAllPricingStructureByGPOId, GetAllRxBlockPricing, GetAllSpecialtyPharmacyNetworkByGPOId, GetFormularyType, GetRebateStructure } from "../../../api/EmpowRxApi/blockPricing";
import editIcon from "../../../assets/icon/pencil-fill.svg"
import Required from "../../../components/Required";
import moment from "moment";
import toastFile from "../../../Service/ToastFile";
import { toast } from "react-toastify";
import CustomButton from "../../../components/common/CustomButton";


const schema = Yup.object().shape({
    Access_Conditions_by_size_or_cost: Yup.string().trim().required("This field requried"),
    GPO: Yup.string().trim().required("This field requried"),
    PBM: Yup.string().trim().required("This field requried"),
    Pricing_Structure: Yup.string().trim().required("This field requried"),
    Rebate_Structure: Yup.string().trim().required("This field requried"),
    Formulary_Type: Yup.string().trim().required("This field requried"),
    Specialty_Pharmacy_Network: Yup.string().trim().required("This field requried"),
});

const schemaModel = Yup.object().shape({
    Presentation_Alias: Yup.string().trim().required("This field is required"),
    Plan_Sponsor_Type: Yup.string().trim().required("This field is required"),
    Benefit_Buying_Approach: Yup.string().trim().required("This field is required"),
    Pricing_Structure: Yup.string().trim().required("This field is required"),
    Formulary_Type: Yup.string().trim().required("This field is required"),
    Rebates_Approach_HIV: Yup.string().trim().required("This field is required"),
    Retail_Network_30_90: Yup.string().trim().required("This field is required"),
    Specialty_Pharmacy_Network: Yup.string().trim().required("This field is required"),
    PBM_Buying_Structure: Yup.string().trim().required("This field is required"),
    // GPO: Yup.string().trim().required("This field is required"),
    PBM: Yup.string().trim().required("This field is required"),
    Access_Conditions_by_size_or_cost: Yup.string().trim().required("This field is required"),
    Contract_Period: Yup.string().trim().required("This field is required"),
    Rebate_Structure: Yup.string().trim().required("This field is required"),
    Retail_30_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_30_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_30_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Retail_90_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_90_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_90_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Mail_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Mail_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Mail_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Specialty_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Specialty_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Specialty_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    // Current_Period: Yup.string().trim().required("This field is required"),
    // Current_Period_Start_Date: Yup.string().trim().required("This field is required"),
    // Current_Period_End_Date: Yup.string().trim().required("This field is required"),
    LDD_Discount: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Per_Claim_Transaction_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Pass_Thru_Admin_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Retail_30_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Retail_90_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Mail_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Specialty_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    LDD_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
});


const ReviewBlockPricing = () => {
    const user = useSelector((state) => state.userDetails.value);
    const userRoleString = "user";
    const searchBtnDisabled = useRef(false);
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [showTable, setShowTable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState();
    const [witchAction, setWitchAction] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isGetData, setIsGetData] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showMoreModal, setShowMoreModal] = useState(false);
    const [blendedMarketAvrg, setBlendedMarketAvrg] = useState([]);
    const [blendedMarketAvrgBlockPricing, setBlendedMarketAvrgBlockPricing] = useState([]);
    const [dropDownList, setDropDownList] = useState({
        GPOList: [],
        PBMList: [],
        rebateStructureList: [],
        accessConditionsList: [],
        pricingStructureList: [],
        formularyTypeList: [],
        specPharmNetworkList: [],
    });
    // const [filterValues, setFilterValues] = useState({});
    
    const formikRef = useRef();

    const blenedColumnObj = [
        {
            header: "",
            accessorKey: "Average_Type",
            enableColumnFilter: false
        },
        {
            header: "Retail 30 Generic",
            accessorKey: "Retail_30_Generic",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Retail 30 Brand",
            accessorKey: "Retail_30_Brand",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Retail 30 Dispensing Fee",
            accessorKey: "Retail_30_Dispensing_Fee",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "Retail 90 Generic",
            accessorKey: "Retail_90_Generic",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Retail 90 Brand",
            accessorKey: "Retail_90_Brand",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Retail 90 Dispensing Fee",
            accessorKey: "Retail_90_Dispensing_Fee",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "Mail Generic",
            accessorKey: "Mail_Generic",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Mail Brand",
            accessorKey: "Mail_Brand",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Mail Dispensing Fee",
            accessorKey: "Mail_Dispensing_Fee",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "Specialty Generic",
            accessorKey: "Specialty_Generic",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Specialty Brand",
            accessorKey: "Specialty_Brand",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "Specialty Dispensing Fee",
            accessorKey: "Specialty_Dispensing_Fee",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "LDD Discount",
            accessorKey: "LDD_Discount",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) => (
                <span>
                    {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                </span>
            ),
        },
        {
            header: "per Claim Transaction Fee",
            accessorKey: "Per_Claim_Transaction_Fee",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "Pass-thru Admin Fee",
            accessorKey: "Pass_thru_Admin_Fee",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),

        },
        {
            header: "Retail 30 Rebate",
            accessorKey: "Retail_30_Rebate",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "Retail 90 Rebate",
            accessorKey: "Retail_90_Rebate",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "Mail Rebate",
            accessorKey: "Mail_Rebate",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "Specialty Rebate",
            accessorKey: "Specialty_Rebate",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            header: "LDD Rebate",
            accessorKey: "LDD_Rebate",
            enableColumnFilter: false,
            filterVariant: "text",
            Cell: ({ cell }) =>
                cell
                    .getValue()
                    .toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
    ]
    const columnBlendedMarketAverage = useMemo(
        () =>
            blenedColumnObj,
        [],
    );
    const column = useMemo(
        () => [
            {
                header: "Actions",
                size: 100,
                enableColumnFilter: false,
                accessorFn: (rowData) =>
                    rowData.status !== "" ? (
                        <div className="text-center">
                            <IoEyeOutline
                                width="11"
                                className="m-2 cursor-pointer"
                                style={{ fontSize: "15px" }}
                                onClick={() => {
                                    setWitchAction("showMore");
                                    setSelectedRowData(rowData);
                                    setShowMoreModal(true);
                                }}
                            />
                            {(user?.UserRole === "Admin" ||
                                user?.IsMarketScanManagementUserRights === 1) && <img
                                    src={editIcon}
                                    width="12"
                                    className="m-2 cursor-pointer"
                                    onClick={() => {
                                        setWitchAction('update');
                                        setSelectedRowData(rowData);
                                        setShowModal(true);
                                    }}
                                />
                            }
                        </div>
                    ) : (
                        <div className="m-2" style={{ height: "11px", width: "11px" }}></div>
                    ),
            },
            {
                header: "Current Period",
                accessorKey: "Current_Period",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Presentation Alias",
                accessorKey: "Presentation_Alias_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            // {
            //     header: "Plan Sponsor Type",
            //     accessorKey: "Plan_Sponsor_Type_Name",
            //     enableColumnFilter: false,
            //     filterVariant: "text",
            // },
            {
                header: "Medical/Pharmacy Benefit Buying Approach",
                accessorKey: "Benefit_Buying_Approach_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Pricing Structure",
                accessorKey: "Pricing_Structure_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Formulary Type",
                accessorKey: "Formulary_Type_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Rebates Approach for HIV Brand Claims",
                accessorKey: "Rebates_Approach_HIV_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Retail Network (30/90)",
                accessorKey: "Retail_Network_30_90_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Specialty Pharmacy Network",
                accessorKey: "Specialty_Pharmacy_Network_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            // {
            //     header: "PBM Buying Structure",
            //     accessorKey: "PBM_Buying_Structure_Name",
            //     enableColumnFilter: false,
            //     filterVariant: "text",
            // },
            {
                header: "GPO (Coalition)",
                accessorKey: "GPO_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "PBM",
                accessorKey: "PBM_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Access Conditions by size or cost",
                accessorKey: "Access_Conditions_by_size_or_cost_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Contract Period",
                accessorKey: "Contract_Period_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Rebate Structure",
                accessorKey: "Rebate_Structure_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Retail 30 Generic",
                accessorKey: "Retail_30_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Retail 30 Brand",
                accessorKey: "Retail_30_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Retail 30 Dispensing Fee",
                accessorKey: "Retail_30_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },                            
            {
                header: "Retail 90 Generic",
                accessorKey: "Retail_90_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Retail 90 Brand",
                accessorKey: "Retail_90_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Retail 90 Dispensing Fee",
                accessorKey: "Retail_90_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Mail Generic",
                accessorKey: "Mail_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Mail Brand",
                accessorKey: "Mail_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Mail Dispensing Fee",
                accessorKey: "Mail_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Specialty Generic",
                accessorKey: "Specialty_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Specialty Brand",
                accessorKey: "Specialty_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "Specialty Dispensing Fee",
                accessorKey: "Specialty_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "LDD Discount",
                accessorKey: "LDD_Discount",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                ),
            },
            {
                header: "per Claim Transaction Fee",
                accessorKey: "Per_Claim_Transaction_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Pass-thru Admin Fee",
                accessorKey: "Pass_thru_Admin_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),

            },
            {
                header: "Retail 30 Rebate",
                accessorKey: "Retail_30_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Retail 90 Rebate",
                accessorKey: "Retail_90_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Mail Rebate",
                accessorKey: "Mail_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Specialty Rebate",
                accessorKey: "Specialty_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "LDD Rebate",
                accessorKey: "LDD_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            
        ],
        [],
    );

    useEffect(() => {
        if (showModal === false) {
            setSelectedRowData(null);
            // setWitchAction('')
        }
    }, [showModal]);

    useEffect(() => {
        getAllRxBlockPricingForAllPeriods()
        getAllRxBlockPricing(true);
        getGPOList();
        getAccessConditionsBySizeOrCost();
        getPricingStructure();
        getFormularyType();
        getSpecPharmNetwork();
        getPBMList();
        getRebateStructure();
    }, []);

    useEffect(() => {
        const tableElement = document.querySelector('.MuiTable-root .MuiTable-stickyHeader .css-lxa89b-MuiTable-root');
        if (tableElement) {
            tableElement.scrollTop = 0;
        }
    }, [data, dropDownList]);

    const handleActions1 = async (values) => {
        // console.log("values", values)
        setShowTable(false);
        let payload = {
            id: selectedRowData?.Id,
            presentation_Alias: JSON.parse(values?.Presentation_Alias).Id,
            plan_Sponsor_Type: +values.Plan_Sponsor_Type,
            benefit_Buying_Approach: +values.Benefit_Buying_Approach,
            pricing_Structure: +values.Pricing_Structure,
            formulary_Type: +values.Formulary_Type,
            rebates_Approach_HIV: +values.Rebates_Approach_HIV,
            retail_Network_30_90: +values.Retail_Network_30_90,
            specialty_Pharmacy_Network: +values.Specialty_Pharmacy_Network,
            pbM_Buying_Structure: +values.PBM_Buying_Structure,
            gpo: +values?.GPO,
            pbm: +values.PBM,
            access_Conditions_by_size_or_cost: +values.Access_Conditions_by_size_or_cost,
            contract_Period: +values.Contract_Period,
            rebate_Structure: +values.Rebate_Structure,
            retail_30_Generic: +values.Retail_30_Generic,
            retail_30_Brand: +values.Retail_30_Brand,
            retail_30_Dispensing_Fee: +values.Retail_30_Dispensing_Fee,
            retail_90_Generic: +values.Retail_90_Generic,
            retail_90_Brand: +values.Retail_90_Brand,
            retail_90_Dispensing_Fee: +values.Retail_90_Dispensing_Fee,
            mail_Generic: +values.Mail_Generic,
            mail_Brand: +values.Mail_Brand,
            mail_Dispensing_Fee: +values.Mail_Dispensing_Fee,
            specialty_Generic: +values.Specialty_Generic,
            specialty_Brand: +values.Specialty_Brand,
            specialty_Dispensing_Fee: +values.Specialty_Dispensing_Fee,
            ldD_Discount: +values.LDD_Discount,
            per_Claim_Transaction_Fee: +values.Per_Claim_Transaction_Fee,
            pass_thru_Admin_Fee: +values.Pass_Thru_Admin_Fee,
            retail_30_Rebate: +values.Retail_30_Rebate,
            retail_90_Rebate: +values.Retail_90_Rebate,
            mail_Rebate: +values.Mail_Rebate,
            specialty_Rebate: +values.Specialty_Rebate,
            ldD_Rebate: +values.LDD_Rebate,
            comments: values.Comments,
            current_Period: values.Current_Period,
            current_Period_Start_Date: values.Current_Period_Start_Date,
            current_Period_End_Date: values.Current_Period_End_Date,
            open_Edit_Start_Date: selectedRowData?.Open_Edit_Start_Date,
            open_Edit_End_Date: selectedRowData?.Open_Edit_End_Date,
            userId: user?.UD_id,
            userRole: userRoleString
        };
        CreateOrUpdateRxBlockPricing(payload).then((res) => {
            if (res?.status === 200) {
                toastFile("update");
                getAllRxBlockPricingForAllPeriods()
                getAllRxBlockPricing();
                getRxBlockPricingFiltered(formikRef?.current?.values);
            } else {
                toast.error("Failed to update Block Pricing rates")
            }
        }).finally(() => {
            setShowModal(false);
        })
    };

    // const getGPOById = () => {
    //     GetGPOById(user?.gpoId)
    //         .then((res) => {
    //             if (res?.status === 200 || res?.status === 204) {
    //                 let data = res.data.data;
    //                 setShowEditIcon(checkDateBetween(data.Start_Date, data.End_Date));
    //                 setOpenEditDate({OpenEditStartDate:data.Start_Date,OpenEditEndDate:data.End_Date})
    //             }
    //         })
    //         .catch((err) => console.log({ err }));
    // }

    const getAllRxBlockPricingForAllPeriods = () => {
        let request_date = moment().format("YYYY-MM-DD");
        let payload = { request_date, all_periods: true };
        GetAllRxBlockPricing(payload)
            .then((res) => {
                if (res?.status === 200) {
                    setAllData(res.data.data);
                } else {
                    console.log('error while getting block pricing data for all periods');
                }
            })
    };
    
    const getAllRxBlockPricing = (updateAll) => {
        setIsLoading(true);
        let request_date = moment().format("YYYY-MM-DD");
        let payload = { request_date };
        GetAllRxBlockPricing(payload)
            .then((res) => {
                if (res?.status === 200) {
                    if (updateAll) {
                        setData(res.data.data);
                        handleBlandedMarket(res.data.data, setBlendedMarketAvrg);
                        setIsLoading(false);
                    }
                    handleBlandedMarket(res.data.data, setBlendedMarketAvrgBlockPricing);
                } else {
                    console.log('error while getting block pricing data');
                }
            })
            .finally(() => {
                if (updateAll) {
                    setShowTable(true);
                    searchBtnDisabled.current = false;
                    setIsLoading(false);
                }
            });
    };

    const getRxBlockPricingFiltered = (values) => {
        setIsLoading(true);
        let request_date = moment().format("YYYY-MM-DD");
        let access_Conditions_by_size_or_cost = values?.Access_Conditions_by_size_or_cost
            ? JSON.parse(values.Access_Conditions_by_size_or_cost)?.Id
            : '';
        let gpo = values?.GPO ? JSON.parse(values.GPO)?.Id : '';
        let pbm = values?.PBM ? JSON.parse(values.PBM)?.Id : '';
        let pricing_Structure = values?.Pricing_Structure
            ? JSON.parse(values.Pricing_Structure)?.Id
            : '';
        let rebate_Structure = values?.Rebate_Structure
            ? JSON.parse(values.Rebate_Structure)?.Id
            : '';
        let formulary_Type = values?.Formulary_Type
            ? JSON.parse(values.Formulary_Type)?.Id
            : '';
        let specialty_Pharmacy_Network = values?.Specialty_Pharmacy_Network
            ? JSON.parse(values.Specialty_Pharmacy_Network)?.Id
            : '';
        let payload = {
            access_Conditions_by_size_or_cost,
            gpo,
            pbm,
            pricing_Structure,
            rebate_Structure,
            formulary_Type,
            specialty_Pharmacy_Network,
            request_date
        };

        GetAllRxBlockPricing(payload)
            .then((res) => {
                if (res?.status === 200) {
                    setData(res.data.data);
                    handleBlandedMarket(res.data.data, setBlendedMarketAvrg);
                    setIsLoading(false);
                } else {
                    console.log('error while getting block pricing fitlered data');
                }
            })
            .finally(() => {
                setShowTable(true);
                searchBtnDisabled.current = false;
                setIsLoading(false);
            });
    };

    const getGPOList = () => {
        GetAllGPO()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, GPOList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getAccessConditionsBySizeOrCost = () => {
        GetAllAccessConditionsbysizeorcost()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, accessConditionsList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getPBMList = (gpoId) => {
        GetAllPBM(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, PBMList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getPricingStructure = (gpoId) => {
        GetAllPricingStructureByGPOId(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, pricingStructureList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getRebateStructure = (gpoID) => {
        GetRebateStructure(gpoID)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, rebateStructureList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };
    const getFormularyType = () => {
        GetFormularyType()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, formularyTypeList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getSpecPharmNetwork = (gpoId) => {
        GetAllSpecialtyPharmacyNetworkByGPOId(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, specPharmNetworkList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

  

    const handleActions = async (values) => {
        searchBtnDisabled.current = true;
        getRxBlockPricingFiltered(values)
    };
    const averageTypes = [
        { id: 1, name: 'Baseline Options Blended Average' },
        { id: 2, name: 'Open Specialty Blended Average' },
        { id: 3, name: 'Pass Through Blended Average' },
        { id: 4, name: 'Standard without Exclusions Blended Average' },
    ]
    const handleBlandedMarket = (results, setBlendedMarketAvrgTable) => {
        const fitlDataByExtType = (extType) => results.filter(result => result.Presentation_Alias_ExtensionType === extType);
        let extTypeFiltDataArr = [];
        for (let i = 0; i < averageTypes.length; i++) {
            extTypeFiltDataArr.push(fitlDataByExtType(i + 1));
        }
        let blendedData = extTypeFiltDataArr.map((filtData, filtInd) => {
            let keyVals = blenedColumnObj.slice(1).reduce((obj, col) => {
                let { accessorKey } = col;
                let avrg = filtData.length > 0 ? (filtData.reduce((acc, curr) => {
                    if (typeof +curr[accessorKey] === 'number') {
                        acc += +curr[accessorKey];
                    }
                    return acc;
                }, 0)) / (filtData.length) : 0;
                obj[accessorKey] = +(avrg);
                return obj;
            }, {});
            // console.log({ keyVals, filtInd });
            return ({ "Average_Type": averageTypes[filtInd]?.name, ...keyVals })
        });
        setBlendedMarketAvrgTable(blendedData);
    }

    const clearCriteria = () => {
        getAllRxBlockPricing(true);
        getPricingStructure();
        getSpecPharmNetwork();
        getPBMList();
        getRebateStructure();
        formikRef.current.resetForm();
    };

    const handleChangeNumberField = (event, handleChange) => {
        const { name, value } = event.target;
        if (/^\d*\.?\d{0,4}$/.test(value)) {
            handleChange({
                target: {
                    name,
                    value: value.trim(),
                },
            });
        }
    };
    

    const handleChangeAmtNumberField = (event, handleChange) => {
        const { name, value } = event.target;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            handleChange({
                target: {
                    name,
                    value: value.trim(),
                },
            });
        }
    };

    const exportAllRate = (data, filename) => {
        let table_col = [...column,  {
         header: "Comments",
         accessorKey: "Comments",
         enableColumnFilter: false,
         filterVariant: "text",
     }]
     const csv = convertToCSV(data, table_col);
     const csvBlob = new Blob([csv], { type: 'text/csv' });
     const csvFile = new File([csvBlob], filename, { type: 'text/csv' });
     const csvUrl = window.URL.createObjectURL(csvFile);
     const link = document.createElement('a');
     link.href = csvUrl;
     link.setAttribute('download', filename);
     document.body.appendChild(link);
     link.click();
     document.body.removeChild(link);
 }

 const convertToCSV = (objArray, columns) => {
     let csv = '';
     const header = columns.slice(1).map(column => {
        if(column.header === "Current Period"){
            return "Period";
        } else {
            return column.header;
        }
    });
     const accessorKey = columns.slice(1).map(column => column.accessorKey);
     csv += header.join(',') + '\r\n';
     objArray?.forEach(obj => {
         const row = accessorKey.map(field => {
            if (obj[field] !== undefined && typeof obj[field] === 'string') {
                let value = obj[field];
                if (value.includes(',')) {
                    value = `"${value}"`;
                }
                if (field === 'Comments') {
                    value = value.replace(/\n/g, ' ');
                }
                if (field === 'Contract_Period_Name') {
                    value = value.replace(/\r\n/g, ' ');
                }
                return value;
            }
            return obj[field] !== undefined ? obj[field] : '';
         });
         csv += row.join(',') + '\r\n';
     });
     return csv;
 }

    return (
        <div>
            <Modal
                show={showMoreModal}
                aria-labelledby="contained-modal-header-vcenter"
                centered
                size="xl" // Removed curly braces as it's a string
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowMoreModal(false);
                    }}
                >
                    <Modal.Title
                        id="contained-modal-header-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        View Rates
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh', overflowY: 'scroll' }}>
                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Presentation Alias
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Presentation_Alias"
                                    value={selectedRowData?.Presentation_Alias_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Plan Sponsor Type
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Plan_Sponsor_Type"
                                    value={selectedRowData?.Plan_Sponsor_Type_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Medical/Pharmacy Benefit Buying Approach
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Benefit_Buying_Approach"
                                    value={selectedRowData?.Benefit_Buying_Approach_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Pricing Structure
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Pricing_Structure"
                                    value={selectedRowData?.Pricing_Structure_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Formulary Type
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Formulary_Type"
                                    value={selectedRowData?.Formulary_Type_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Rebates Approach for HIV Brand Claims
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Rebates_Approach_HIV"
                                    value={selectedRowData?.Rebates_Approach_HIV_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Retail Network (30/90)
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Retail_Network_30_90"
                                    value={selectedRowData?.Retail_Network_30_90_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Pharmacy Network
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Specialty_Pharmacy_Network"
                                    value={selectedRowData?.Specialty_Pharmacy_Network_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    PBM Buying Structure
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="PBM_Buying_Structure"
                                    value={selectedRowData?.PBM_Buying_Structure_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    GPO (Coalition)
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="GPO"
                                    value={selectedRowData?.GPO_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    PBM
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="PBM"
                                    value={selectedRowData?.PBM_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Access Conditions by size or cost
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Access_Conditions_by_size_or_cost"
                                    value={selectedRowData?.Access_Conditions_by_size_or_cost_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="w-50 mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Contract Period
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Contract_Period"
                                    value={selectedRowData?.Contract_Period_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Rebate Structure
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Rebate_Structure"
                                    value={selectedRowData?.Rebate_Structure_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="d-flex mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col xs={8}>
                            <Row className=" mb-2 gap-3" style={{ alignItems: 'end' }}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 30 Generic
                                        </Form.Label>

                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_30_Generic"
                                            value={selectedRowData?.Retail_30_Generic ? `${(selectedRowData.Retail_30_Generic * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 30 Brand
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_30_Brand"
                                            value={selectedRowData?.Retail_30_Brand ? `${(selectedRowData.Retail_30_Brand * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 30 Dispensing Fee
                                        </Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                            <Form.Control
                                                className="py-1 rounded-0"
                                                style={Fontstyling.label}
                                                disabled
                                                name="Retail_30_Dispensing_Fee"
                                                value={(+selectedRowData?.Retail_30_Dispensing_Fee).toFixed(2)}
                                            >
                                            </Form.Control>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className=" mb-2 gap-3" style={{ alignItems: 'end' }}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 90 Generic
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_90_Generic"
                                            value={selectedRowData?.Retail_90_Generic ? `${(selectedRowData.Retail_90_Generic * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 90 Brand
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_90_Brand"
                                            value={selectedRowData?.Retail_90_Brand ? `${(selectedRowData.Retail_90_Brand * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 90 Dispensing Fee
                                        </Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                            <Form.Control
                                                className="py-1 rounded-0"
                                                style={Fontstyling.label}
                                                disabled
                                                name="Retail_90_Dispensing_Fee"
                                                value={(+selectedRowData?.Retail_90_Dispensing_Fee).toFixed(2)}
                                            >
                                            </Form.Control>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className=" mb-2 gap-3" style={{ alignItems: 'end' }}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Mail Generic
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Mail_Generic"
                                            value={selectedRowData?.Mail_Generic ? `${(selectedRowData.Mail_Generic * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Mail Brand
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Mail_Brand"
                                            value={selectedRowData?.Mail_Brand ? `${(selectedRowData.Mail_Brand * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Mail Dispensing Fee
                                        </Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                            <Form.Control
                                                className="py-1 rounded-0"
                                                style={Fontstyling.label}
                                                disabled
                                                name="Mail_Dispensing_Fee"
                                                value={(+selectedRowData?.Mail_Dispensing_Fee).toFixed(2)}
                                            >
                                            </Form.Control>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row className=" mb-2 gap-3" style={{ alignItems: 'end' }}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            GPO Comments
                                        </Form.Label>
                                        <Form.Control
                                            rows={12}
                                            as="textarea"
                                            type="text"
                                            className="py-1 rounded-0"
                                            style={{ ...Fontstyling.label, height: '163px' }}
                                            disabled
                                            name="Comments"
                                            value={selectedRowData?.Comments}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Generic
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Specialty_Generic"
                                    value={selectedRowData?.Specialty_Generic ? `${(selectedRowData.Specialty_Generic * 100).toFixed(2)}%` : ""}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Brand
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Specialty_Brand"
                                    value={selectedRowData?.Specialty_Brand ? `${(selectedRowData.Specialty_Brand * 100).toFixed(2)}%` : ""}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Dispensing Fee
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Specialty_Dispensing_Fee"
                                        value={(+selectedRowData?.Specialty_Dispensing_Fee).toFixed(2)}
                                        >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Created Date
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    type="date"
                                    name="Created_Date"
                                    value={selectedRowData?.Created_Date?.split("T")[0]}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    LDD Discount
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="LDD_Discount"
                                    value={selectedRowData?.LDD_Discount ? `${(selectedRowData.LDD_Discount * 100).toFixed(2)}%` : ""}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    per Claim Transaction Fee
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Per_Claim_Transaction_Fee"
                                        value={(+selectedRowData?.Per_Claim_Transaction_Fee).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Pass-thru Admin Fee
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Pass-thru_Admin_Fee"
                                        // value={selectedRowData?.['Pass-thru_Admin_Fee']}
                                        value={(+selectedRowData?.Pass_thru_Admin_Fee).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Modified Date
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    type="date"
                                    name="Modified_Date"
                                    value={selectedRowData?.Modified_Date?.split("T")[0]}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Retail 30 Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Retail_30_Rebate"
                                        value={(+selectedRowData?.Retail_30_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Retail 90 Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Retail_90_Rebate"
                                        value={(+selectedRowData?.Retail_90_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Mail Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Mail_Rebate"
                                        value={(+selectedRowData?.Mail_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Modified By
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Modified_By"
                                    value={selectedRowData?.Modified_By_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="w-50 mb-2 gap-3" style={{ alignItems: 'end' }}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Specialty_Rebate"
                                        value={(+selectedRowData?.Specialty_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    LDD Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="LDD_Rebate"
                                        value={(+selectedRowData?.LDD_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        style={Fontstyling.cancelbutton}
                        type="reset"
                        onClick={() => {
                            setShowMoreModal(false);
                        }}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="xl"
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowModal(false);
                        setSelectedRowData([])
                    }}
                >
                    <Modal.Title
                        id="contained-modal-title-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        Update Rates
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh', overflowY: 'scroll' }}>
                    <Formik
                        enableReinitialize
                        validationSchema={schemaModel}
                        onSubmit={(values) => {
                                handleActions1(values);
                        }}
                        initialValues={{
                            Presentation_Alias: selectedRowData ?JSON.stringify({
                                Id: selectedRowData?.Presentation_Alias_Id,
                                Label: selectedRowData?.Presentation_Alias_Name,
                                ExtensionType:selectedRowData?.Presentation_Alias_ExtensionType,
                            }) : '',
                            Plan_Sponsor_Type: selectedRowData ? selectedRowData?.Plan_Sponsor_Type_Id : '',
                            Benefit_Buying_Approach: selectedRowData ? selectedRowData?.Benefit_Buying_Approach_Id : '',
                            Pricing_Structure: selectedRowData ? selectedRowData?.Pricing_Structure_Id : '',
                            Formulary_Type: selectedRowData ? selectedRowData?.Formulary_Type_Id : '',
                            Rebates_Approach_HIV: selectedRowData ? selectedRowData?.Rebates_Approach_HIV_Id : '',
                            Retail_Network_30_90: selectedRowData ? selectedRowData?.Retail_Network_30_90_Id : '',
                            Specialty_Pharmacy_Network: selectedRowData ? selectedRowData?.Specialty_Pharmacy_Network_Id : '',
                            PBM_Buying_Structure: selectedRowData ? selectedRowData?.PBM_Buying_Structure_Id : '',
                            GPO: selectedRowData?.GPO_Id ?? '',
                            PBM: selectedRowData ? selectedRowData?.PBM_Id : '',
                            Access_Conditions_by_size_or_cost: selectedRowData ? selectedRowData?.Access_Conditions_by_size_or_cost_Id : '',
                            Contract_Period: selectedRowData ? selectedRowData?.Contract_Period_Id : '',
                            Rebate_Structure: selectedRowData ? selectedRowData?.Rebate_Structure_Id : '',
                            Retail_30_Generic: selectedRowData ? (+selectedRowData?.Retail_30_Generic).toFixed(4) : '',
                            Retail_30_Brand: selectedRowData ? (+selectedRowData?.Retail_30_Brand).toFixed(4) : '',
                            Retail_30_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Retail_30_Dispensing_Fee).toFixed(2) : '',
                            Retail_90_Generic: selectedRowData ? (+selectedRowData?.Retail_90_Generic).toFixed(4) : '',
                            Retail_90_Brand: selectedRowData ? (+selectedRowData?.Retail_90_Brand).toFixed(4) : '',
                            Retail_90_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Retail_90_Dispensing_Fee).toFixed(2) : '',
                            Mail_Generic: selectedRowData ? (+selectedRowData?.Mail_Generic).toFixed(4) : '',
                            Mail_Brand: selectedRowData ? (+selectedRowData?.Mail_Brand).toFixed(4) : '',
                            Mail_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Mail_Dispensing_Fee).toFixed(2) : '',
                            Comments: selectedRowData ? selectedRowData?.Comments : '',
                            Specialty_Generic: selectedRowData ? (+selectedRowData?.Specialty_Generic).toFixed(4) : '',
                            Specialty_Brand: selectedRowData ? (+selectedRowData?.Specialty_Brand).toFixed(4) : '',
                            Specialty_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Specialty_Dispensing_Fee).toFixed(2) : '',
                            Current_Period: selectedRowData?.Current_Period ?? '',
                            LDD_Discount: selectedRowData ? (+selectedRowData?.LDD_Discount).toFixed(4) : '',
                            Per_Claim_Transaction_Fee: selectedRowData ? (+selectedRowData?.Per_Claim_Transaction_Fee).toFixed(2) : '',
                            Pass_Thru_Admin_Fee: selectedRowData ? (+selectedRowData?.Pass_thru_Admin_Fee).toFixed(2) : '',
                            Current_Period_Start_Date: selectedRowData?.Current_Period_Start_Date ?? '',
                            Retail_30_Rebate: selectedRowData ? (+selectedRowData?.Retail_30_Rebate).toFixed(2) : '',
                            Retail_90_Rebate: selectedRowData ? (+selectedRowData?.Retail_90_Rebate).toFixed(2) : '',
                            Mail_Rebate: selectedRowData ?(+selectedRowData?.Mail_Rebate).toFixed(2) : '',
                            Current_Period_End_Date: selectedRowData?.Current_Period_End_Date ?? '',
                            Specialty_Rebate: selectedRowData ? (+selectedRowData?.Specialty_Rebate).toFixed(2) : '',
                            LDD_Rebate: selectedRowData ? (+selectedRowData?.LDD_Rebate).toFixed(2) : '',
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            handleBlur,
                            setFieldValue,
                            values,
                            touched,
                            isValid,
                            errors,
                            resetForm
                        }) => {
                            const handleFormSubmit = async (e) => {
                                e.preventDefault();
                                 handleSubmit(e);
                                if (Object.keys(errors).length > 0) {
                                    const firstErrorField = Object.keys(errors)[0];
                                    const errorFieldElement = document.getElementsByName(firstErrorField)[0];
                                    if (errorFieldElement) {
                                        errorFieldElement.focus();
                                    }
                                }
                            };
                            return (
                                <Form onSubmit={(e) => {
                                    handleFormSubmit(e);
                                }} id="submitblockPricingExtrnal" >
                                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Presentation Alias
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Presentation_Alias"
                                                    value={selectedRowData?.Presentation_Alias_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Plan Sponsor Type
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Plan_Sponsor_Type"
                                                    value={selectedRowData?.Plan_Sponsor_Type_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Medical/Pharmacy Benefit Buying Approach
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Benefit_Buying_Approach"
                                                    value={selectedRowData?.Benefit_Buying_Approach_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Pricing Structure
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Pricing_Structure"
                                                    value={selectedRowData?.Pricing_Structure_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Formulary Type
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Formulary_Type"
                                                    value={selectedRowData?.Formulary_Type_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Rebates Approach for HIV Brand Claims
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Rebates_Approach_HIV"
                                                    value={selectedRowData?.Rebates_Approach_HIV_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Retail Network (30/90)
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Retail_Network_30_90"
                                                    value={selectedRowData?.Retail_Network_30_90_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Pharmacy Network
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Specialty_Pharmacy_Network"
                                                    value={selectedRowData?.Specialty_Pharmacy_Network_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2 gap-3" style={{ alignItems: 'end' }}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    PBM Buying Structure
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="PBM_Buying_Structure"
                                                    value={selectedRowData?.PBM_Buying_Structure_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    GPO (Coalition)
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="GPO"
                                                    value={selectedRowData?.GPO_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    PBM
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="PBM"
                                                    value={selectedRowData?.PBM_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Access Conditions by size or cost
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Access_Conditions_by_size_or_cost"
                                                    value={selectedRowData?.Access_Conditions_by_size_or_cost_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="w-50 mb-2 gap-3" style={{ alignItems: 'end' }}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Contract Period
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Contract_Period"
                                                    value={selectedRowData?.Contract_Period_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Rebate Structure
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Rebate_Structure"
                                                    value={selectedRowData?.Rebate_Structure_Name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="d-flex mb-2 gap-3" >
                                        <Col 
                                        xs={8}
                                        >
                                            <Row className=" mb-3 gap-3" style={{alignItems:'end'}}>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 30 Generic (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            name="Retail_30_Generic"
                                                            type='text'
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            isInvalid={
                                                                values.Retail_30_Generic === "" &&
                                                                errors.Retail_30_Generic &&
                                                                touched.Retail_30_Generic
                                                            }
                                                            value={values?.Retail_30_Generic}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_30_Generic && touched.Retail_30_Generic && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_30_Generic}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 30 Brand (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Retail_30_Brand === "" &&
                                                                errors.Retail_30_Brand &&
                                                                touched.Retail_30_Brand
                                                            }
                                                            name="Retail_30_Brand"
                                                            value={values?.Retail_30_Brand}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_30_Brand && touched.Retail_30_Brand && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_30_Brand}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 30 Dispensing Fee
                                                              <Required />
                                                        </Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                            <Form.Control
                                                                className="py-1 rounded-0"
                                                                style={Fontstyling.label}
                                                                onChange={(event) =>
                                                                    handleChangeAmtNumberField(event, handleChange)
                                                                }
                                                                onBlur={handleBlur}
                                                                maxLength={20}
                                                                type='text'
                                                                isInvalid={
                                                                    values.Retail_30_Dispensing_Fee === "" &&
                                                                    errors.Retail_30_Dispensing_Fee &&
                                                                    touched.Retail_30_Dispensing_Fee
                                                                }
                                                                name="Retail_30_Dispensing_Fee"
                                                                value={values?.Retail_30_Dispensing_Fee}
                                                            >
                                                            </Form.Control>
                                                        </InputGroup>
                                                        {errors.Retail_30_Dispensing_Fee && touched.Retail_30_Dispensing_Fee && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_30_Dispensing_Fee}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className=" mb-3 gap-3" style={{alignItems:'end'}}>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 90 Generic (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Retail_90_Generic === "" &&
                                                                errors.Retail_90_Generic &&
                                                                touched.Retail_90_Generic
                                                            }
                                                            name="Retail_90_Generic"
                                                            value={values?.Retail_90_Generic}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_90_Generic && touched.Retail_90_Generic && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_90_Generic}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 90 Brand (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Retail_90_Brand === "" &&
                                                                errors.Retail_90_Brand &&
                                                                touched.Retail_90_Brand
                                                            }
                                                            name="Retail_90_Brand"
                                                            value={values?.Retail_90_Brand}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_90_Brand && touched.Retail_90_Brand && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_90_Brand}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-nowrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 90 Dispensing Fee
                                                              <Required />
                                                        </Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                            <Form.Control
                                                                className="py-1 rounded-0"
                                                                style={Fontstyling.label}
                                                                onChange={(event) =>
                                                                    handleChangeAmtNumberField(event, handleChange)
                                                                }
                                                                onBlur={handleBlur}
                                                                maxLength={20}
                                                                type='text'
                                                                isInvalid={
                                                                    values.Retail_90_Dispensing_Fee === "" &&
                                                                    errors.Retail_90_Dispensing_Fee &&
                                                                    touched.Retail_90_Dispensing_Fee
                                                                }
                                                                name="Retail_90_Dispensing_Fee"
                                                                value={values?.Retail_90_Dispensing_Fee}
                                                            >
                                                            </Form.Control>
                                                        </InputGroup>
                                                        {errors.Retail_90_Dispensing_Fee && touched.Retail_90_Dispensing_Fee && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_90_Dispensing_Fee}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className=" mb-3 gap-3" style={{alignItems:'end'}}>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Mail Generic (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Mail_Generic === "" &&
                                                                errors.Mail_Generic &&
                                                                touched.Mail_Generic
                                                            }
                                                            name="Mail_Generic"
                                                            value={values?.Mail_Generic}
                                                        >
                                                        </Form.Control>
                                                        {errors.Mail_Generic && touched.Mail_Generic && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Mail_Generic}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Mail Brand (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Mail_Brand === "" &&
                                                                errors.Mail_Brand &&
                                                                touched.Mail_Brand
                                                            }
                                                            name="Mail_Brand"
                                                            value={values?.Mail_Brand}
                                                        >
                                                        </Form.Control>
                                                        {errors.Mail_Brand && touched.Mail_Brand && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Mail_Brand}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-nowrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Mail Dispensing Fee
                                                              <Required />
                                                        </Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                            <Form.Control
                                                                className="py-1 rounded-0"
                                                                style={Fontstyling.label}
                                                                onChange={(event) =>
                                                                    handleChangeAmtNumberField(event, handleChange)
                                                                }
                                                                onBlur={handleBlur}
                                                                maxLength={20}
                                                                type='text'
                                                                isInvalid={
                                                                    values.Mail_Dispensing_Fee === "" &&
                                                                    errors.Mail_Dispensing_Fee &&
                                                                    touched.Mail_Dispensing_Fee
                                                                }
                                                                name="Mail_Dispensing_Fee"
                                                                value={values?.Mail_Dispensing_Fee}
                                                            >
                                                            </Form.Control>
                                                        </InputGroup>
                                                        {errors.Mail_Dispensing_Fee && touched.Mail_Dispensing_Fee && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Mail_Dispensing_Fee}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row className=" mb-3 gap-3">
                                                <Col >
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-nowrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            GPO Comments
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            as="textarea"
                                                            rows={12}
                                                            style={{ ...Fontstyling.label, height: "100%" }}
                                                            name="Comments"
                                                            type='text'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            isInvalid={
                                                                values.Comments === "" &&
                                                                errors.Comments &&
                                                                touched.Comments
                                                            }
                                                            value={values?.Comments}
                                                        >
                                                        </Form.Control>
                                                        {errors.Comments && touched.Comments && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Comments}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" style={{alignItems:'end'}}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-wrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Generic (e.g, enter 0.2575 for 25.75%)
                                                      <Required />
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={(event) =>
                                                        handleChangeNumberField(event, handleChange)
                                                    }
                                                    onBlur={handleBlur}
                                                    type='text'
                                                    isInvalid={
                                                        values.Specialty_Generic === "" &&
                                                        errors.Specialty_Generic &&
                                                        touched.Specialty_Generic
                                                    }
                                                    name="Specialty_Generic"
                                                    value={values?.Specialty_Generic}
                                                >
                                                </Form.Control>
                                                {errors.Specialty_Generic && touched.Specialty_Generic && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Generic}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-wrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Brand (e.g, enter 0.2575 for 25.75%)
                                                      <Required />
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={(event) =>
                                                        handleChangeNumberField(event, handleChange)
                                                    }
                                                    onBlur={handleBlur}
                                                    type='text'
                                                    isInvalid={
                                                        values.Specialty_Brand === "" &&
                                                        errors.Specialty_Brand &&
                                                        touched.Specialty_Brand
                                                    }
                                                    name="Specialty_Brand"
                                                    value={values?.Specialty_Brand}
                                                >
                                                </Form.Control>
                                                {errors.Specialty_Brand && touched.Specialty_Brand && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Brand}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Dispensing Fee
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        type='text'
                                                        isInvalid={
                                                            values.Specialty_Dispensing_Fee === "" &&
                                                            errors.Specialty_Dispensing_Fee &&
                                                            touched.Specialty_Dispensing_Fee
                                                        }
                                                        name="Specialty_Dispensing_Fee"
                                                        value={values?.Specialty_Dispensing_Fee}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Specialty_Dispensing_Fee && touched.Specialty_Dispensing_Fee && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Dispensing_Fee}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Created Date
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    type="date"
                                                    name="Created_Date"
                                                    value={selectedRowData?.Created_Date?.split("T")[0]}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" style={{alignItems:'end'}}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-wrap "
                                                    style={Fontstyling.label}
                                                >
                                                    LDD Discount (e.g, enter 0.2575 for 25.75%)
                                                      <Required />
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={(event) =>
                                                        handleChangeNumberField(event, handleChange)
                                                    }
                                                    onBlur={handleBlur}
                                                    type='text'
                                                    isInvalid={
                                                        values.LDD_Discount === "" &&
                                                        errors.LDD_Discount &&
                                                        touched.LDD_Discount
                                                    }
                                                    name="LDD_Discount"
                                                    value={values?.LDD_Discount}
                                                >
                                                </Form.Control>
                                                {errors.LDD_Discount && touched.LDD_Discount && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.LDD_Discount}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    per Claim Transaction Fee
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        type='text'
                                                        isInvalid={
                                                            values.Per_Claim_Transaction_Fee === "" &&
                                                            errors.Per_Claim_Transaction_Fee &&
                                                            touched.Per_Claim_Transaction_Fee
                                                        }
                                                        name="Per_Claim_Transaction_Fee"
                                                        value={values?.Per_Claim_Transaction_Fee}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Per_Claim_Transaction_Fee && touched.Per_Claim_Transaction_Fee && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Per_Claim_Transaction_Fee}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Pass-thru Admin Fee
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        type='text'
                                                        isInvalid={
                                                            values.Pass_Thru_Admin_Fee === "" &&
                                                            errors.Pass_Thru_Admin_Fee &&
                                                            touched.Pass_Thru_Admin_Fee
                                                        }
                                                        name="Pass_Thru_Admin_Fee"
                                                        value={values?.Pass_Thru_Admin_Fee}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Pass_Thru_Admin_Fee && touched.Pass_Thru_Admin_Fee && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Pass_Thru_Admin_Fee}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Modified Date
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    type="text"
                                                    name="Modified_Date"
                                                    value={moment().format('MM/DD/YYYY')}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Retail 30 Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Retail_30_Rebate === "" &&
                                                            errors.Retail_30_Rebate &&
                                                            touched.Retail_30_Rebate
                                                        }
                                                        name="Retail_30_Rebate"
                                                        value={values?.Retail_30_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Retail_30_Rebate && touched.Retail_30_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Retail_30_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Retail 90 Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Retail_90_Rebate === "" &&
                                                            errors.Retail_90_Rebate &&
                                                            touched.Retail_90_Rebate
                                                        }
                                                        name="Retail_90_Rebate"
                                                        value={values?.Retail_90_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Retail_90_Rebate && touched.Retail_90_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Retail_90_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Mail Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Mail_Rebate === "" &&
                                                            errors.Mail_Rebate &&
                                                            touched.Mail_Rebate
                                                        }
                                                        name="Mail_Rebate"
                                                        value={values?.Mail_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Mail_Rebate && touched.Mail_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Mail_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Modified By
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="Modified_By"
                                                    value={user?.UD_emp_name}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="w-50 mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Specialty_Rebate === "" &&
                                                            errors.Specialty_Rebate &&
                                                            touched.Specialty_Rebate
                                                        }
                                                        name="Specialty_Rebate"
                                                        value={values?.Specialty_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Specialty_Rebate && touched.Specialty_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    LDD Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.LDD_Rebate === "" &&
                                                            errors.LDD_Rebate &&
                                                            touched.LDD_Rebate
                                                        }
                                                        name="LDD_Rebate"
                                                        value={values.LDD_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.LDD_Rebate && touched.LDD_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.LDD_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
                <Modal.Footer>
                    <div className="text-end">
                        <button
                            style={Fontstyling.cancelbutton}
                            type="reset"
                            onClick={() => {
                                setShowModal(false);
                                setSelectedRowData([]);
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="ms-3"
                            style={Fontstyling.savebutton}
                            type="submit"
                            form="submitblockPricingExtrnal"
                        >
                            Save
                        </button>
                    </div>

                </Modal.Footer>
            </Modal>
            <div className="d-flex align-items-center justify-content-between">
                <p style={{ ...Fontstyling.heading, textDecoration: 'underline' }}>Search Criteria:</p>
                <CustomButton
                    className='px-4 py-2 rounded'
                    style={{ ...Fontstyling.cancelbutton }}
                    onClick={() => exportAllRate(allData, "Rx_Block_Pricing.csv")}
                >
                    Export All Rate
                </CustomButton>
            </div>
            <Formik
                enableReinitialize
                innerRef={formikRef}
                // validationSchema={schema}
                onSubmit={handleActions}
                initialValues={{
                    Access_Conditions_by_size_or_cost: '',
                    GPO: "",
                    PBM: "",
                    Pricing_Structure: "",
                    Rebate_Structure: "",
                    Formulary_Type: "",
                    Specialty_Pharmacy_Network: "",
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    values,
                    touched,
                    errors,
                    resetForm
                }) => {
                    return (
                        <Form onSubmit={(e) => {
                            handleSubmit(e);
                        }} id="blockPricingInternal" >
                            <Row className=" my-3 gap-5 justify-content-between ">
                                <Col className=" ">
                                    <Form.Group className="gap-3 align-items-end">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Aggregator/Coalition/GPO/PBM
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            name="GPO"
                                            onChange={(e) => {
                                                handleChange(e);
                                                let { value } = e.target;
                                                let val = value && JSON.parse(value);
                                                getPBMList(val?.Id);
                                                getRebateStructure(val?.Id);
                                                getPricingStructure(val?.Id);
                                                getSpecPharmNetwork(val?.Id);
                                                setFieldValue('PBM', "");
                                                setFieldValue("Rebate_Structure", "");
                                                setFieldValue("Specialty_Pharmacy_Network", "");
                                                setFieldValue("Pricing_Structure", "");
                                            }}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.GPO &&
                                                touched.GPO
                                            }
                                            value={values.GPO}
                                        >
                                            <option value={""}>Select Aggregator/Coalition/GPO/PBM</option>
                                            {dropDownList.GPOList?.map((el, elInd) => (
                                                <option key={elInd}
                                                    value={JSON.stringify(el)}
                                                // value={el}
                                                >
                                                    {el.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.GPO && touched.GPO && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.GPO}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col className=" ">
                                    <Form.Group className="gap-3 align-items-end">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            PBM
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            name="PBM"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.PBM &&
                                                touched.PBM
                                            }
                                            value={values.PBM}
                                        >
                                            <option value={""}>Select PBM</option>
                                            {dropDownList.PBMList?.filter((pbm) => {
                                                return (pbm.Id?.length === 0 || pbm?.Id)
                                            })?.map((npbm, npbmInd) => (
                                                <option key={npbmInd} value={JSON.stringify(npbm)}>
                                                    {npbm?.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.PBM && touched.PBM && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.PBM}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col className=" ">
                                    <Form.Group className="gap-3 align-items-end">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Access Conditions by size or cost
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            name="Access_Conditions_by_size_or_cost"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.Access_Conditions_by_size_or_cost &&
                                                touched.Access_Conditions_by_size_or_cost
                                            }
                                            value={values.Access_Conditions_by_size_or_cost}
                                        >
                                            <option value={""}>Select Access Conditions by size or cost</option>
                                            {dropDownList.accessConditionsList?.map((item, index) => (
                                                <option key={index} value={JSON.stringify(item)}>
                                                    {item.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.Access_Conditions_by_size_or_cost && touched.Access_Conditions_by_size_or_cost && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.Access_Conditions_by_size_or_cost}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className=" my-3 gap-5 justify-content-between ">
                                <Col className=" ">
                                    <Form.Group className="gap-3 align-items-end">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Pricing Structure
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            name="Pricing_Structure"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.Pricing_Structure &&
                                                touched.Pricing_Structure
                                            }
                                            value={values.Pricing_Structure}
                                        >
                                            <option value={""}>Select Pricing Structure</option>

                                            {dropDownList.pricingStructureList?.map((el, elInd) => (
                                                <option key={elInd} value={JSON.stringify(el)}>
                                                    {el?.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.Pricing_Structure && touched.Pricing_Structure && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.Pricing_Structure}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col className=" ">
                                    <Form.Group className="gap-3 align-items-end">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Rebate Structure
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            name="Rebate_Structure"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.Rebate_Structure &&
                                                touched.Rebate_Structure
                                            }
                                            value={values.Rebate_Structure}
                                        >
                                            <option value={""}>Select Rebate Structure</option>
                                            {dropDownList.rebateStructureList?.filter((el) => {
                                                return (el.Id?.length === 0 || el?.Id)
                                            })?.map((el2, el2Ind) => (

                                                <option key={el2Ind} value={JSON.stringify(el2)}>
                                                    {el2?.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.Rebate_Structure && touched.Rebate_Structure && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.Rebate_Structure}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col className=" ">
                                    <Form.Group className="gap-3 align-items-end">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Formulary Type
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            name="Formulary_Type"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.Formulary_Type &&
                                                touched.Formulary_Type
                                            }
                                            value={values.Formulary_Type}
                                        >
                                            <option value={""}>Select Formulary Type</option>
                                            {dropDownList.formularyTypeList?.map((el, elInd) => (
                                                <option key={elInd} value={JSON.stringify(el)}>
                                                    {el.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.Formulary_Type && touched.Formulary_Type && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.Formulary_Type}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="my-3 gap-5 justify-content-between" style={{ alignItems: 'end' }}>
                                <Col className=" ">
                                    <Form.Group className="gap-3 align-items-end">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Specialty Pharmacy Network
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={{ ...Fontstyling.label, width: '309px' }}
                                            name="Specialty_Pharmacy_Network"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.Specialty_Pharmacy_Network &&
                                                touched.Specialty_Pharmacy_Network
                                            }
                                            value={values.Specialty_Pharmacy_Network}
                                        >
                                            <option value={""}>Select Rebate Structure</option>
                                            {dropDownList.specPharmNetworkList?.map((el, elInd) => (
                                                <option key={elInd} value={JSON.stringify(el)}>
                                                    {el.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.Specialty_Pharmacy_Network && touched.Specialty_Pharmacy_Network && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.Specialty_Pharmacy_Network}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col className="col-3 d-flex gap-3" style={{ justifyContent: 'end' }}>
                                    <Button
                                        style={Fontstyling.cancelbutton}
                                        onClick={clearCriteria}
                                    >
                                        Clear Criteria
                                    </Button>
                                    <Button
                                        disabled={searchBtnDisabled.current}
                                        form="blockPricingInternal"
                                        type="submit"
                                        style={Fontstyling.savebutton}
                                    >
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    );
                }}
            </Formik>
            <div className='d-flex mb-2 mt-5 justify-content-between'>
                <div  style={{ ...Fontstyling.heading, textDecoration: 'underline' }}>Search Results:  </div>
                {!isLoading && <div style={{ ...Fontstyling.heading}}>Total Records : {data?.length}</div>}
            </div>
            <div className='blockTable'>
                {showTable && (<CustomReactMaterialTable
                    data={data}
                    columns={column}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    setWitchAction={setWitchAction}
                    setSelectedRowData={setSelectedRowData}
                    setShowModal={setShowModal}
                    isLoading={isLoading}
                    isExport={false}
                    isEdit={true}
                    isDelete={true}
                    isActionColumn={false}
                    isPagination={false}
                />)}
            </div>
            <div className="mb-2 mt-5 " style={{ ...Fontstyling.heading, textDecoration: 'underline' }}>Blended Market Average (with Selected Criteria):</div>
            <div className='blockTable'>
                {showTable && (
                    <CustomReactMaterialTable
                        columns={columnBlendedMarketAverage}
                        data={blendedMarketAvrg}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        setWitchAction={setWitchAction}
                        setSelectedRowData={setSelectedRowData}
                        setShowModal={setShowModal}
                        isLoading={isLoading}
                        isExport={false}
                        isEdit={false}
                        isDelete={false}
                        isActionColumn={false}
                        isPagination={false}
                    />
                )}
            </div>
            <div className="mb-2 mt-5 " style={{ ...Fontstyling.heading, textDecoration: 'underline' }}>Blended Market Average (All Block Pricing):</div>
            <div className='blockTable'>
                {showTable && (
                    <CustomReactMaterialTable
                        columns={columnBlendedMarketAverage}
                        data={blendedMarketAvrgBlockPricing}
                        selectedRow={selectedRow}
                        setSelectedRow={setSelectedRow}
                        setWitchAction={setWitchAction}
                        setSelectedRowData={setSelectedRowData}
                        setShowModal={setShowModal}
                        isLoading={isLoading}
                        isExport={false}
                        isEdit={false}
                        isDelete={false}
                        isActionColumn={false}
                        isPagination={false}
                    />
                )}
            </div>
        </div>
    );
};

export default ReviewBlockPricing;